var _$20$30$40$50$60$;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (_$20$30$40$50$60$ = {}, _defineProperty(_$20$30$40$50$60$, 10, '#fcf2e6'), _defineProperty(_$20$30$40$50$60$, 20, '#fad8af'), _defineProperty(_$20$30$40$50$60$, 30, '#f5bc76'), _defineProperty(_$20$30$40$50$60$, 40, '#e89c3f'), _defineProperty(_$20$30$40$50$60$, 50, '#cf7911'), _defineProperty(_$20$30$40$50$60$, 60, '#ad5f00'), _defineProperty(_$20$30$40$50$60$, 70, '#8a4d03'), _defineProperty(_$20$30$40$50$60$, 80, '#693d07'), _defineProperty(_$20$30$40$50$60$, 90, '#4d2f0b'), _defineProperty(_$20$30$40$50$60$, 100, '#33210c'), _$20$30$40$50$60$);